import { htmlToElement } from "@modules/bookmarks/html-parser"

export const tagsListItem: string = `<div class="auftrag-tag{activeClass}" data-tag-id="{tagSlug}" data-tag="{tagName}">
        <span class="tag-icon">
            <svg viewBox="0 0 20 20">
                <path d="M17.9,0l-1.3,0h-5c-0.6,0-1.1,0.2-1.5,0.6L1,9.8c-0.8,0.8-0.8,2.1,0,2.8L7.4,19c0.8,0.8,2.1,0.8,2.8,0l9.2-9.2C19.8,9.4,20,8.9,20,8.3V2.1C20,0.9,19.1,0,17.9,0z M19,2.1v6.3c0,0.3-0.1,0.6-0.3,0.7l-9.2,9.2c-0.4,0.4-1,0.4-1.4,0l-6.4-6.4c-0.4-0.4-0.4-1,0-1.4l9.2-9.2C11.1,1.1,11.4,1,11.6,1h6.3C18.5,1,19,1.5,19,2.1z"></path>
                <path d="M15,3c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S16.1,3,15,3z M15,6c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S15.6,6,15,6z"></path>
            </svg>
          </span>
        <span class="auftrag-tag-label cut-text">{tagName}</span>
    </div>`

export const tagAssignTagsBoxListItem: string = `<div class="auftrag-tag{activeClass}" data-tag-id="{tagSlug}" data-tag="{tagName}">
        <span class="auftrag-tag-label cut-text">{tagName}</span>
        <span class="icon dark inline lower icon-16">
            <svg viewBox="0 0 20 20">
                <path d="M1.008 8.827l6.633 5.608 11.272-10.976 1.087 1.118-12.286 11.964-7.714-6.523z"></path>
            </svg>
        </span>
    </div>`

export const makeTagsListItem = (tagName: string, tagSlug: string): HTMLDivElement => {
    return htmlToElement(
        tagsListItem
            .replace(/\{tagSlug}/g, tagSlug)
            .replace(/\{tagName}/g, tagName)
            .replace("{activeClass}", ""),
    )
}
